/*
 * Purpose: keep any explicitly selected alternate PDP view after native color
 * changes; ordinary assigned templates must stay on their own product URL.
 * Usage: loaded by the shared PDP style-control section.
 * Scope: mvk-pdp-pilot only; no network requests or variant/cart ownership.
 * Impulse replaces the whole query string after dispatching variantChange. A
 * microtask restores the alternate view and existing preview/market parameters.
 * Shopify can consume preview_theme_id into its preview cookie before scripts run;
 * do not manufacture a theme ID or assume the parameter must remain in the URL.
 */
(() => {
  const initialize = () => {
    if (!document.querySelector('.mvk-pdp-pilot') || window.mvkPdpPreviewReady) return;
    window.mvkPdpPreviewReady = true;
    const initial = new URL(window.location.href);
    const preview = ['preview_theme_id', 'country', 'pb']
      .filter(key => initial.searchParams.has(key))
      .map(key => [key, initial.searchParams.get(key)]);
    if (initial.searchParams.has('view')) {
      preview.push(['view', initial.searchParams.get('view')]);
    }
    document.addEventListener('variantChange', event => {
      if (!event.target.closest?.('.mvk-pdp-pilot')) return;
      queueMicrotask(() => {
        const url = new URL(window.location.href);
        for (const [key, value] of preview) url.searchParams.set(key, value);
        history.replaceState(history.state, '', url);
      });
    }, true); // Native variantChange does not bubble; capture observes its owner.
  };
  // Consent managers may execute a deferred body script before parsing completes.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
})();
